<template>
<form action="" class="form">
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">{{$t('openTitle')}}</p>
    </header>
    <section class="modal-card-body">
      <div class="box is-hidden-mobile" style="min-width: 30rem">

        <div class="columns is-gapless header-row has-text-weight-bold">
          <div class="column is-6 header-col">{{$t('name')}}</div>
          <div class="column header-col">{{$t('modifiedAt')}}</div>
        </div>

        <div class="columns is-gapless list-box">
          <div class="column is-6 list-col">
            <ul>
              <li v-for="(list, index) in shoppingLists"
                :key="list.id"
                :class="[{ selected: selectedIndex === index }, 'truncate', `list-item-${index}`]"
                @click="select(index)">
                {{ list.name }}
              </li>
            </ul>
          </div>

          <div class="column list-col">
            <ul>
              <li v-for="(list, index) in shoppingLists"
                :key="list.id" 
                :class="[{ selected: selectedIndex === index }, 'truncate', `list-item-${index}`]"
                @click="select(index)">
                {{ formatDate(list.modifiedAt) }}
               </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="is-hidden-tablet">
        <b-dropdown v-model="selectedIndex">
          <button class="button is-primary" type="button" slot="trigger">
            <template v-if="selectedIndex === null">
              <span>Choose Shopping List</span>
            </template>
            <template v-if="selectedIndex !== null">
              <span class="truncate">{{shoppingLists[selectedIndex].name}}</span>
            </template>
            <b-icon icon="caret-down"></b-icon>
          </button>

          <b-dropdown-item v-for="(list, index) in shoppingLists"
            :key="list.id"
            :value="index">
            <p aria-role="button" class="truncate">{{list.name}}</p>
            <p aria-role="button" class="is-size-7">{{formatDate(list.modifiedAt)}}</p>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <!--
      <div class="field">
        <b-checkbox v-model="makeDefault">
          {{ $t('makeDefault') }}
        </b-checkbox>
      </div>
      -->
    </section>
    <footer class="modal-card-foot fix-footer">
      <button class="button" @click="$parent.close()" type="button">{{$t('cancelButton')}}</button>

      <button :disabled="selectedIndex === null"
        class="button is-primary"
        @click="openList">{{$t('openButton')}}
      </button>
    </footer>
  </div>
</form>
</template>

<i18n src="../../i18n/ShoppingList.i18n.json"></i18n>

<script>
import { isNumber } from 'lodash';
import i18nMixin from '@/mixins/i18n';
import routingMixin from '@/mixins/routing';
import { LISTS_QUERY } from '../../graphql/shopping-list';
import { getErrorMessage } from '../../utils/errors';

export default {
  name: 'shoppingListModalOpen',
  data() {
    return {
      shoppingLists: null,

      selectedIndex: null,
      makeDefault: false,
    };
  },
  apollo: {
    shoppingLists: {
      query: LISTS_QUERY,
      error(err) {
        this.$toast.open({
          message: getErrorMessage(err),
          type: 'is-danger',
        });

        this.$parent.close();
      },
    },
  },
  mixins: [i18nMixin, routingMixin],
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    select(index) {
      this.selectedIndex = index;
    },
    formatDate(modifiedAt) {
      return new Date(modifiedAt).toLocaleString();
    },
    handleKeyDown(event) {
      let index = null;

      if (event.code === 'ArrowDown') {
        if (isNumber(this.selectedIndex)) {
          if (this.selectedIndex < this.shoppingLists.length - 1) {
            index = this.selectedIndex + 1;
          }
        } else {
          index = 0;
        }
      } else if (event.code === 'ArrowUp') {
        if (isNumber(this.selectedIndex)) {
          if (this.selectedIndex > 0) {
            index = this.selectedIndex - 1;
          }
        } else {
          index = 0;
        }
      } else if (event.code === 'Enter') {
        if (isNumber(this.selectedIndex)) {
          this.openList();
        }
      }

      if (index !== null) {
        this.select(index);

        // Decide if we need to scroll
        const listBoxEl = document.getElementsByClassName('list-box')[0];
        const listBoxRect = listBoxEl.getBoundingClientRect();
        const listItemRect = document.getElementsByClassName(`list-item-${index}`)[0].getBoundingClientRect();
        if (listItemRect.bottom > listBoxRect.bottom) {
          const numItemsFit = Math.floor(listBoxRect.height / listItemRect.height);
          const extra = (listBoxRect.height % listItemRect.height) - 1;
          listBoxEl.scrollTop = ((index - numItemsFit) * listItemRect.height) + extra;
        } else if (listItemRect.top < listBoxRect.top) {
          listBoxEl.scrollTop -= listBoxRect.top - listItemRect.top;
        }

        event.preventDefault();
      }
    },
    openList() {
      this.$emit('ok', this.shoppingLists[this.selectedIndex]);
    },
  },
};

</script>

<style lang="sass" scoped>
.form
  user-select: none

.header-row
  border-bottom: 1px solid black
  margin-bottom: 0 !important

.header-col
  padding-bottom: 5px

.header-col:last-child
  margin-left: -0.5rem !important

.list-box
  overflow-y: scroll
  max-height: 10rem
  padding-top: 0
  margin-top: 5px
  cursor: pointer

.list-col
  padding-top: 0
  background-clip: border-box

.truncate
  text-overflow: ellipsis
  white-space: nowrap
  overflow: hidden

.selected
  background-color: #00d1b2

.fix-footer
  justify-content: flex-end
</style>



// WEBPACK FOOTER //
// src/components/shopping-list/ShoppingListModalOpen.vue